var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SessionError } from '@embed/errors';
import { uuidv4 } from '@embed/helpers';
import { sendPixelTracking } from '@embed/store/tools/tracking/sendPixelTracking';
import { clearSession, getLastActivity, getStoredSession, setLastActivity, setSession, } from './guest.storage';
import { fetchGuestId, fetchOrCreateGuestId, isExpired, isValidGuestId, setGuestId, } from './helpers';
const VERSION = '2020-06-11';
const MIN_ACTIVITY = 1000 * 60 * 30; // 30 minutes
export const fetchSession = ({ guestId }) => __awaiter(void 0, void 0, void 0, function* () {
    const sessionId = uuidv4();
    const expires_in = 60 * 60;
    const now = new Date();
    const session = {
        expires_in,
        expires_at: new Date(now.getTime() + expires_in * 1000),
        guest_id: guestId,
        id: sessionId,
        referrer: typeof document !== 'undefined' && document.referrer,
        type: 'embed_session',
        version: VERSION,
        visitor_id: guestId,
        visitor_session_id: `${guestId}${sessionId}`,
    };
    sendPixelTracking({
        url: '/trk/session:session_create',
        data: {
            guest_id: guestId,
            session_id: session.id,
        },
    });
    setSession(session);
    return {
        session,
        guestId,
    };
});
window._fwnSessionPromise = null;
export const getSession = (__guestIdFetcher = fetchOrCreateGuestId, __sessionFetcher = fetchSession) => {
    try {
        let guestId = undefined;
        const session = getStoredSession() || {};
        try {
            guestId = fetchGuestId();
        }
        catch (error) { }
        if (!guestId || !isValidGuestId(guestId)) {
            throw new SessionError('Missing guest id');
        }
        validateActivity();
        validateSession(session);
        return { guestId, session };
    }
    catch (error) {
        if (error instanceof SessionError) {
            // SessionError occured, lets
            // refresh session from server
            clearSession();
            if (window._fwnSessionPromise) {
                return window._fwnSessionPromise;
            }
            window._fwnSessionPromise = __guestIdFetcher().then((guestId) => {
                setGuestId(guestId);
                return __sessionFetcher({
                    guestId,
                }).then(({ session }) => {
                    window._fwnSessionPromise = null;
                    setLastActivity();
                    return { guestId, session };
                });
            });
            return window._fwnSessionPromise;
        }
        else {
            throw error;
        }
    }
};
export const validateActivity = () => {
    const lastActivity = getLastActivity();
    if (lastActivity && new Date() - lastActivity > MIN_ACTIVITY) {
        throw new SessionError('Inacivity');
    }
};
export const validateSession = (session) => {
    const { expires_at, version } = session || {};
    if (VERSION !== version) {
        throw new SessionError('Invalid session version');
    }
    if (!expires_at || isExpired(expires_at)) {
        throw new SessionError('Expired session token');
    }
};
